var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-button',_vm._g(_vm._b({attrs:{"href":_vm.upgradeUrl,"target":"_blank"}},'core-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v("Upgrade Now & Save 35%")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }